function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1980(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 20.66,
    height: 11.17,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.8592307692307692
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.33,
    y: 5.585
  }, "\n        Chattahoochee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 11.17,
    width: 20.66,
    height: 11.63,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9383333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.33,
    y: 16.985
  }, "\n        Echols\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 22.8,
    width: 20.66,
    height: 12.43,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.7757142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.33,
    y: 29.015
  }, "\n        Quitman\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 35.24,
    width: 20.66,
    height: 13.96,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9942857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.33,
    y: 42.22
  }, "\n        Webster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 49.2,
    width: 20.66,
    height: 14.17,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.417
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.33,
    y: 56.285000000000004
  }, "\n        Taliaferro\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 63.37,
    width: 20.66,
    height: 16.12,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.686666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.33,
    y: 71.42999999999999
  }, "\n        Schley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 79.49,
    width: 20.66,
    height: 16.9,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.1125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.33,
    y: 87.94
  }, "\n        Glascock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 96.39,
    width: 20.66,
    height: 18.43,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.6075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.33,
    y: 105.605
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 114.83,
    width: 20.66,
    height: 23.23,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.132
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.33,
    y: 126.445
  }, "\n        Baker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 138.06,
    width: 20.66,
    height: 23.83,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4433333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.33,
    y: 149.975
  }, "\n        Lanier\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 161.89,
    width: 20.66,
    height: 25.89,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.165
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.33,
    y: 174.83499999999998
  }, "\n        Long\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 187.78,
    width: 20.66,
    height: 26.34,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4433333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.33,
    y: 200.95
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 214.12,
    width: 20.66,
    height: 27.29,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.4433333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.33,
    y: 227.76500000000001
  }, "\n        Dawson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 241.4,
    width: 20.66,
    height: 27.69,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4433333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.33,
    y: 255.245
  }, "\n        Clinch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 269.09,
    width: 20.66,
    height: 29.77,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.33,
    y: 283.97499999999997
  }, "\n        Treutlen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 298.86,
    width: 20.66,
    height: 30.5,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.4433333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.33,
    y: 314.11
  }, "\n        Miller\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 329.36,
    width: 20.66,
    height: 31,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.9514285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.33,
    y: 344.86
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 360.36,
    width: 20.66,
    height: 31,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.9514285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.33,
    y: 375.86
  }, "\n        Stewart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 391.36,
    width: 20.66,
    height: 32.47,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.9514285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.33,
    y: 407.595
  }, "\n        Wheeler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 423.84,
    width: 20.66,
    height: 33.01,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.33,
    y: 440.34499999999997
  }, "\n        Atkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 456.84,
    width: 20.66,
    height: 33.32,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4433333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.33,
    y: 473.5
  }, "\n        Talbot\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 490.16,
    width: 20.66,
    height: 33.91,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.132
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.33,
    y: 507.115
  }, "\n        Heard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 524.08,
    width: 20.66,
    height: 33.96,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.33,
    y: 541.0600000000001
  }, "\n        Charlton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 558.03,
    width: 20.66,
    height: 34.48,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4433333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.33,
    y: 575.27
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 592.51,
    width: 20.66,
    height: 35.28,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.33,
    y: 610.15
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 627.79,
    width: 20.66,
    height: 35.96,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.9514285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.33,
    y: 645.77
  }, "\n        Candler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 663.75,
    width: 20.66,
    height: 36.25,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.9514285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.33,
    y: 681.875
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.66,
    y: 0,
    width: 25.63,
    height: 29.74,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.2716666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 33.475,
    y: 14.87
  }, "\n        Jasper\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.29,
    y: 0,
    width: 25.73,
    height: 29.74,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.6757142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 59.155,
    y: 14.87
  }, "\n        Jenkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.02,
    y: 0,
    width: 26.57,
    height: 29.74,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.314
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 85.30499999999999,
    y: 14.87
  }, "\n        Evans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.59,
    y: 0,
    width: 27.14,
    height: 29.74,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.523333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.16,
    y: 14.87
  }, "\n        Wilcox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 125.73,
    y: 0,
    width: 27.16,
    height: 29.74,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.432
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.31,
    y: 14.87
  }, "\n        Irwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 152.89,
    y: 0,
    width: 27.24,
    height: 29.74,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.7239999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 166.51,
    y: 14.87
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180.13,
    y: 0,
    width: 27.84,
    height: 29.74,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.64
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 194.04999999999998,
    y: 14.87
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 207.98,
    y: 0,
    width: 28.31,
    height: 29.74,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.53875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 222.135,
    y: 14.87
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 236.28,
    y: 0,
    width: 28.99,
    height: 29.74,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.1414285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 250.775,
    y: 14.87
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 265.27,
    y: 0,
    width: 29.47,
    height: 29.74,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.947
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 280.005,
    y: 14.87
  }, "\n        Oglethorpe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 294.74,
    y: 0,
    width: 29.6,
    height: 29.74,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.92
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 309.54,
    y: 14.87
  }, "\n        Banks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 324.34,
    y: 0,
    width: 30.14,
    height: 29.74,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.956666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 339.40999999999997,
    y: 14.87
  }, "\n        Turner\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 354.48,
    y: 0,
    width: 30.3,
    height: 29.74,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.7175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 369.63,
    y: 14.87
  }, "\n        Seminole\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 384.78,
    y: 0,
    width: 30.72,
    height: 29.74,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 400.14,
    y: 14.87
  }, "\n        Brantley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 415.5,
    y: 0,
    width: 30.75,
    height: 29.74,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.956666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 430.875,
    y: 14.87
  }, "\n        Twiggs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 446.25,
    y: 0,
    width: 30.8,
    height: 29.74,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.956666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 461.65,
    y: 14.87
  }, "\n        Pierce\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 477.05,
    y: 0,
    width: 31.26,
    height: 29.74,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.248571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 492.68,
    y: 14.87
  }, "\n        Johnson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 508.31,
    y: 0,
    width: 31.46,
    height: 29.74,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 524.04,
    y: 14.87
  }, "\n        McIntosh\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 539.77,
    y: 0,
    width: 31.63,
    height: 29.74,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.9479999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 555.585,
    y: 14.87
  }, "\n        Towns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 571.4,
    y: 0,
    width: 31.84,
    height: 29.74,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.248571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 587.3199999999999,
    y: 14.87
  }, "\n        Lumpkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 603.24,
    y: 0,
    width: 31.93,
    height: 29.74,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.435
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 619.205,
    y: 14.87
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 635.16,
    y: 0,
    width: 32.05,
    height: 29.74,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.9479999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 651.185,
    y: 14.87
  }, "\n        Bacon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 667.22,
    y: 0,
    width: 32.78,
    height: 29.74,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.956666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 683.61,
    y: 14.87
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.66,
    y: 29.74,
    width: 32.43,
    height: 30.59,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.37
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.875,
    y: 45.035
  }, "\n        Pulaski\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.66,
    y: 60.33,
    width: 32.43,
    height: 30.62,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.1240000000000006
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.875,
    y: 75.64
  }, "\n        Bryan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.66,
    y: 90.94,
    width: 32.43,
    height: 31.11,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.2219999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.875,
    y: 106.495
  }, "\n        White\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.66,
    y: 122.05,
    width: 32.43,
    height: 31.33,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.133
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.875,
    y: 137.715
  }, "\n        Jeff_Davis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.66,
    y: 153.39,
    width: 32.43,
    height: 31.33,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.266
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.875,
    y: 169.05499999999998
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.66,
    y: 184.72,
    width: 32.43,
    height: 32.37,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.624285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.875,
    y: 200.905
  }, "\n        Terrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.66,
    y: 217.09,
    width: 32.43,
    height: 32.56,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.05375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.875,
    y: 233.37
  }, "\n        Bleckley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.66,
    y: 249.64,
    width: 32.43,
    height: 33.08,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.486
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.875,
    y: 266.18
  }, "\n        Rabun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.66,
    y: 282.72,
    width: 32.43,
    height: 33.14,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.486
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.875,
    y: 299.29
  }, "\n        Dooly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.66,
    y: 315.86,
    width: 32.43,
    height: 33.43,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.6033333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.875,
    y: 332.575
  }, "\n        Wilkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.66,
    y: 349.29,
    width: 32.43,
    height: 33.81,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.405
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.875,
    y: 366.19500000000005
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.66,
    y: 383.1,
    width: 32.43,
    height: 34.29,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.405
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.875,
    y: 400.245
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.66,
    y: 417.39,
    width: 32.43,
    height: 34.65,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.81
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.875,
    y: 434.715
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.66,
    y: 452.04,
    width: 32.43,
    height: 34.68,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.632857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.875,
    y: 469.38
  }, "\n        Screven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.66,
    y: 486.71,
    width: 32.43,
    height: 34.74,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.405
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.875,
    y: 504.08
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.66,
    y: 521.45,
    width: 32.43,
    height: 34.85,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.486
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.875,
    y: 538.875
  }, "\n        Early\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.66,
    y: 556.3,
    width: 32.43,
    height: 34.86,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.1075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.875,
    y: 573.7299999999999
  }, "\n        Cook\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.66,
    y: 591.17,
    width: 32.43,
    height: 36.22,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.405
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.875,
    y: 609.28
  }, "\n        Brooks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.66,
    y: 627.38,
    width: 32.43,
    height: 36.23,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.486
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.875,
    y: 645.495
  }, "\n        Lamar\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.66,
    y: 663.61,
    width: 32.43,
    height: 36.39,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.486
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.875,
    y: 681.8050000000001
  }, "\n        Butts\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.09,
    y: 29.74,
    width: 33.19,
    height: 35.7,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.531666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.685,
    y: 47.59
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.28,
    y: 29.74,
    width: 33.78,
    height: 35.7,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 103.17,
    y: 47.59
  }, "\n        Dade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120.05,
    y: 29.74,
    width: 33.88,
    height: 35.7,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.840000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 136.99,
    y: 47.59
  }, "\n        Telfair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 153.94,
    y: 29.74,
    width: 34.21,
    height: 35.7,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.8420000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 171.045,
    y: 47.59
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 188.14,
    y: 29.74,
    width: 34.97,
    height: 35.7,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.37125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 205.625,
    y: 47.59
  }, "\n        Ben_Hill\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 223.11,
    y: 29.74,
    width: 35.05,
    height: 35.7,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.007142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 240.63500000000002,
    y: 47.59
  }, "\n        Pickens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 258.16,
    y: 29.74,
    width: 37.54,
    height: 35.7,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.95
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 276.93,
    y: 47.59
  }, "\n        Oconee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 295.7,
    y: 29.74,
    width: 37.86,
    height: 35.7,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.1000000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 314.63,
    y: 47.59
  }, "\n        Berrien\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 333.57,
    y: 29.74,
    width: 38.2,
    height: 35.7,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.95
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 352.67,
    y: 47.59
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 371.76,
    y: 29.74,
    width: 39.01,
    height: 35.7,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.95
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 391.265,
    y: 47.59
  }, "\n        Gilmer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 410.77,
    y: 29.74,
    width: 40.26,
    height: 35.7,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.1000000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 430.9,
    y: 47.59
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 451.03,
    y: 29.74,
    width: 40.26,
    height: 35.7,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.4625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 471.15999999999997,
    y: 47.59
  }, "\n        McDuffie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 491.29,
    y: 29.74,
    width: 40.36,
    height: 35.7,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.140000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 511.47,
    y: 47.59
  }, "\n        Worth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 531.66,
    y: 29.74,
    width: 40.42,
    height: 35.7,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.95
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 551.87,
    y: 47.59
  }, "\n        Murray\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 572.07,
    y: 29.74,
    width: 42.49,
    height: 35.7,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.95
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 593.315,
    y: 47.59
  }, "\n        Harris\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 614.56,
    y: 29.74,
    width: 42.64,
    height: 35.7,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.4625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 635.88,
    y: 47.59
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 657.2,
    y: 29.74,
    width: 42.8,
    height: 35.7,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.966666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 678.6,
    y: 47.59
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.09,
    y: 65.44,
    width: 42.4,
    height: 36.13,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.226000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.29,
    y: 83.505
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.09,
    y: 101.57,
    width: 42.4,
    height: 36.21,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.52625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.29,
    y: 119.675
  }, "\n        Tattnall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.09,
    y: 137.77,
    width: 42.4,
    height: 36.24,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.177142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.29,
    y: 155.89000000000001
  }, "\n        Appling\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.09,
    y: 174.02,
    width: 42.4,
    height: 37.04,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.4079999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.29,
    y: 192.54000000000002
  }, "\n        Grady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.09,
    y: 211.06,
    width: 42.4,
    height: 37.42,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.484
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.29,
    y: 229.77
  }, "\n        Peach\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.09,
    y: 248.48,
    width: 42.4,
    height: 37.79,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.558
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.29,
    y: 267.375
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.09,
    y: 286.27,
    width: 42.4,
    height: 38.7,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.74
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.29,
    y: 305.62
  }, "\n        Crisp\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.09,
    y: 324.97,
    width: 42.4,
    height: 38.83,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.883
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.29,
    y: 344.38500000000005
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.09,
    y: 363.8,
    width: 42.4,
    height: 38.92,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.3244444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.29,
    y: 383.26
  }, "\n        Effingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.09,
    y: 402.72,
    width: 42.4,
    height: 39.1,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.585714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.29,
    y: 422.27000000000004
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.09,
    y: 441.82,
    width: 42.4,
    height: 42.02,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.202
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.29,
    y: 462.83
  }, "\n        Meriwether\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.09,
    y: 483.83,
    width: 42.4,
    height: 42.19,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.031666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.29,
    y: 504.92499999999995
  }, "\n        Fannin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.09,
    y: 526.03,
    width: 42.4,
    height: 42.39,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.29875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.29,
    y: 547.225
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.09,
    y: 568.42,
    width: 42.4,
    height: 43.14,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.3
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.29,
    y: 589.99
  }, "\n        Haralson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.09,
    y: 611.56,
    width: 42.4,
    height: 43.87,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.066666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.29,
    y: 633.4949999999999
  }, "\n        Elbert\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.09,
    y: 655.43,
    width: 42.4,
    height: 44.57,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.48
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.29,
    y: 677.7149999999999
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.49,
    y: 65.44,
    width: 39.98,
    height: 47.57,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.663333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 115.47999999999999,
    y: 89.225
  }, "\n        Toombs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135.47,
    y: 65.44,
    width: 40.1,
    height: 47.57,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 155.52,
    y: 89.225
  }, "\n        Hart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.57,
    y: 65.44,
    width: 40.28,
    height: 47.57,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.7542857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 195.70999999999998,
    y: 89.225
  }, "\n        Decatur\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 215.85,
    y: 65.44,
    width: 40.33,
    height: 47.57,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.761428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 236.015,
    y: 89.225
  }, "\n        Emanuel\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 256.18,
    y: 65.44,
    width: 40.7,
    height: 47.57,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.783333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 276.53000000000003,
    y: 89.225
  }, "\n        Barrow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 296.88,
    y: 65.44,
    width: 40.84,
    height: 47.57,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.537777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 317.3,
    y: 89.225
  }, "\n        Chattooga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 337.72,
    y: 65.44,
    width: 41.63,
    height: 47.57,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.326
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 358.535,
    y: 89.225
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 379.36,
    y: 65.44,
    width: 42.72,
    height: 47.57,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.12
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 400.72,
    y: 89.225
  }, "\n        Coffee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 422.07,
    y: 65.44,
    width: 43.18,
    height: 47.57,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.3975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 443.65999999999997,
    y: 89.225
  }, "\n        Stephens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 465.25,
    y: 65.44,
    width: 43.75,
    height: 47.57,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.861111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 487.125,
    y: 89.225
  }, "\n        Habersham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 509,
    y: 65.44,
    width: 44.83,
    height: 47.57,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.404285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 531.415,
    y: 89.225
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 553.83,
    y: 65.44,
    width: 47.12,
    height: 47.57,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.853333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 577.39,
    y: 89.225
  }, "\n        Walton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 600.95,
    y: 65.44,
    width: 49.26,
    height: 47.57,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.514
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 625.58,
    y: 89.225
  }, "\n        Upson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 650.21,
    y: 65.44,
    width: 49.79,
    height: 47.57,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.94625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 675.105,
    y: 89.225
  }, "\n        Paulding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.49,
    y: 113.01,
    width: 50.45,
    height: 47.06,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.722857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.715,
    y: 136.54000000000002
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.49,
    y: 160.07,
    width: 50.45,
    height: 48.8,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.2
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.715,
    y: 184.47
  }, "\n        Tift\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.49,
    y: 208.86,
    width: 50.45,
    height: 49.03,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.171666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.715,
    y: 233.375
  }, "\n        Sumter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 120,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.49,
    y: 257.89,
    width: 50.45,
    height: 50.65,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.207142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.715,
    y: 283.215
  }, "\n        Baldwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 121,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.49,
    y: 308.54,
    width: 50.45,
    height: 51.96,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.408333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.715,
    y: 334.52000000000004
  }, "\n        Gordon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 122,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.49,
    y: 360.5,
    width: 50.45,
    height: 52.08,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.6125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.715,
    y: 386.54
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 123,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.49,
    y: 412.58,
    width: 50.45,
    height: 54.27,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.207142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.715,
    y: 439.715
  }, "\n        Bulloch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 124,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.49,
    y: 466.85,
    width: 50.45,
    height: 55.09,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.408333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.715,
    y: 494.39500000000004
  }, "\n        Newton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 125,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.49,
    y: 521.93,
    width: 50.45,
    height: 55.17,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.30625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.715,
    y: 549.515
  }, "\n        Colquitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 126,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.49,
    y: 577.1,
    width: 50.45,
    height: 61.24,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.30625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.715,
    y: 607.72
  }, "\n        Rockdale\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 127,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.49,
    y: 638.34,
    width: 50.45,
    height: 61.66,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.6125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.715,
    y: 669.1700000000001
  }, "\n        Ware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 128,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.94,
    y: 113.01,
    width: 56.15,
    height: 55.54,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.256666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 174.015,
    y: 140.78
  }, "\n        Thomas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 129,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 202.09,
    y: 113.01,
    width: 57.59,
    height: 55.54,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.256666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 230.885,
    y: 140.78
  }, "\n        Coweta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 130,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 259.69,
    y: 113.01,
    width: 58.3,
    height: 55.54,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.934285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 288.84,
    y: 140.78
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 131,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 317.99,
    y: 113.01,
    width: 59.98,
    height: 55.54,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.256666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 347.98,
    y: 140.78
  }, "\n        Bartow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 132,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 377.96,
    y: 113.01,
    width: 61.12,
    height: 55.54,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.934285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 408.52,
    y: 140.78
  }, "\n        Catoosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 133,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 439.08,
    y: 113.01,
    width: 62.27,
    height: 55.54,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.108
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 470.215,
    y: 140.78
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 134,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 501.35,
    y: 113.01,
    width: 64.54,
    height: 55.54,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.9425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 533.62,
    y: 140.78
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 135,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.88,
    y: 113.01,
    width: 65.97,
    height: 55.54,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.9425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 598.865,
    y: 140.78
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 136,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 631.86,
    y: 113.01,
    width: 68.14,
    height: 55.54,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.9425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 665.9300000000001,
    y: 140.78
  }, "\n        Spalding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 137,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.94,
    y: 168.54,
    width: 65.44,
    height: 58.73,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.389999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 178.66,
    y: 197.905
  }, "\n        Laurens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 138,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.94,
    y: 227.27,
    width: 65.44,
    height: 60.56,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.651428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 178.66,
    y: 257.55
  }, "\n        Lowndes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 139,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.94,
    y: 287.83,
    width: 65.44,
    height: 62.98,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.596
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 178.66,
    y: 319.32
  }, "\n        Troup\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 140,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.94,
    y: 350.81,
    width: 65.44,
    height: 66.28,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.906666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 178.66,
    y: 383.95
  }, "\n        Walker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 141,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.94,
    y: 417.09,
    width: 65.44,
    height: 66.77,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.348571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 178.66,
    y: 450.47499999999997
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 142,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.94,
    y: 483.86,
    width: 65.44,
    height: 67.89,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.348571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 178.66,
    y: 517.8050000000001
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 143,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.94,
    y: 551.74,
    width: 65.44,
    height: 71.16,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.088
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 178.66,
    y: 587.32
  }, "\n        Glynn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 144,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.94,
    y: 622.9,
    width: 65.44,
    height: 77.1,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.271111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 178.66,
    y: 661.4499999999999
  }, "\n        Whitfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 145,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 211.38,
    y: 168.54,
    width: 65.09,
    height: 93.83,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.848333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 243.925,
    y: 215.45499999999998
  }, "\n        Clarke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 146,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 276.47,
    y: 168.54,
    width: 67.12,
    height: 93.83,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.78
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 310.03000000000003,
    y: 215.45499999999998
  }, "\n        Hall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 147,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 343.6,
    y: 168.54,
    width: 67.69,
    height: 93.83,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.67
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 377.44500000000005,
    y: 215.45499999999998
  }, "\n        Houston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 148,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 411.29,
    y: 168.54,
    width: 77.18,
    height: 93.83,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.436000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 449.88,
    y: 215.45499999999998
  }, "\n        Floyd\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 149,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 488.48,
    y: 168.54,
    width: 87.06,
    height: 93.83,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.673333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 532.01,
    y: 215.45499999999998
  }, "\n        Dougherty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 150,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 575.53,
    y: 168.54,
    width: 124.47,
    height: 93.83,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.404285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 637.765,
    y: 215.45499999999998
  }, "\n        Clayton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 151,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 211.38,
    y: 262.37,
    width: 129.05,
    height: 94.1,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.7625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 275.905,
    y: 309.42
  }, "\n        Muscogee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 152,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 211.38,
    y: 356.46,
    width: 129.05,
    height: 106.71,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.33875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 275.905,
    y: 409.815
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 153,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 211.38,
    y: 463.18,
    width: 129.05,
    height: 114.46,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 28.615
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 275.905,
    y: 520.41
  }, "\n        Bibb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 154,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 211.38,
    y: 577.64,
    width: 129.05,
    height: 122.36,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.295
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 275.905,
    y: 638.8199999999999
  }, "\n        Gwinnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 155,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 340.43,
    y: 262.37,
    width: 133.79,
    height: 130.25,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.607142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 407.325,
    y: 327.495
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 156,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 474.23,
    y: 262.37,
    width: 225.77,
    height: 130.25,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 32.5625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 587.115,
    y: 327.495
  }, "\n        Cobb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 157,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 340.43,
    y: 392.62,
    width: 167.14,
    height: 307.38,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 27.856666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 424,
    y: 546.31
  }, "\n        DeKalb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 158,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 507.58,
    y: 392.62,
    width: 192.42,
    height: 307.38,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 32.07
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 603.79,
    y: 546.31
  }, "\n        Fulton\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1980);
export default __webpack_public_path__ + "static/media/1980.2ff6d7fedd2d1996d8c84904d49bfdd9.svg";
export { ForwardRef as ReactComponent };